module.exports = __webpack_public_path__ + "static/img/mills-static.d8dea72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mills-static.png
// module id = 13
// module chunks = 0